import { render } from "./DropdownDefaultButtons.vue?vue&type=template&id=74c96ee9&ts=true"
import script from "./DropdownDefaultButtons.vue?vue&type=script&lang=ts"
export * from "./DropdownDefaultButtons.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__